import type { FaireProductEntity } from "../../entity_types/product";

export const p_vmz2a964c8: FaireProductEntity = {
  token: "p_vmz2a964c8",
  type: "product",
  name: "Chirps and Cheers Little Notes® Duo Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/47eb3610b05ee61d8ec50e7c11033b6e6c68a67bd3b9d7331c7136f4404f322c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/54e7cc30076601dfcfd1d09884e958fa91d93ff0ac33e3f8cc87d49c69209b8f.jpeg",
    "https://cdn.faire.com/fastly/17a34c07e79a246110c1c71acc5d87d4e9c0b0873269eda8c5fa97608421de56.jpeg",
    "https://cdn.faire.com/fastly/7af08a88bb25c899002d4103eabc48d3e486b7aa3798fc9e114a1c80e01ada99.jpeg",
    "https://cdn.faire.com/fastly/256101ad1bce4948ee9defe52a7e960642a7692ec267cae57abb34b8ee09d8e7.jpeg",
  ],
  priceDollars: 6,
  description:
    "The cutest little duos you ever did see. Set of 10 Little Notes® and 10 Little Note Envelopes. These corresponding Little Notes® and printed envelopes take the surprise and delight of Little Notes to the next level - so up your gift tag/secret note/barista tip game! Please note: These envelopes are so adorably tiny that they're too small for the postal service, so hand-deliver only!",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:21.913Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
